import React from "react";
import { Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { estiloEstatus, soloFecha } from "./datosVisitas";

// Modal de detalle de visita — datos reales de VisitasCRM/ObtenerVisitaID + ObtenerTimeLine
export const VisitasModalDetalle = ({ open, visita, timeline = [], onClose, onEditar, onEditarEstatus, onAgregarComentario, puedeRevertir = false, onRevertirEstatus }) => {
  if (!visita) return null;
  const pr = estiloEstatus(visita.estatus);
  const esRealizada = visita.estatus === "R";
  const esVencida = visita.estatus === "V";
  const puedeMarcarRealizada = !esRealizada && !esVencida;

  return (
    <Modal open={open} onClose={onClose}>
      <div className="crm-modal-card crm-modal-card-lg">
        <button type="button" className="crm-modal-cerrar" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </button>

        <div className="crm-modal-titulo vp-modal-titulo-visita">
          <h3>{visita.razon_social}</h3>
          <span className="vp-modal-titulo-asesor">{visita.vendedor}</span>
        </div>

        <div className="crm-modal-body">
          <span className="vp-estatus-pill" style={{ background: pr.bg, color: pr.fg, width: "fit-content" }}>
            {visita.estatus_texto}
          </span>

          <div className="vp-row2">
            <div className="crm-field">
              <label>Fecha de visita</label>
              <div className="crm-field-readonly">{soloFecha(visita.fecha_visita)}</div>
            </div>
            <div className="crm-field">
              <label>Fecha de creación</label>
              <div className="crm-field-readonly">{soloFecha(visita.createdate)}</div>
            </div>
          </div>

          <div className="vp-row2">
            <div className="crm-field">
              <label>Tipo de visita</label>
              <div className="crm-field-readonly">{visita.visita}</div>
            </div>
            <div className="crm-field">
              <label>Línea</label>
              <div className="crm-field-readonly">{visita.linea || "—"}</div>
            </div>
          </div>

          {timeline.length > 0 && (
            <div className="crm-field">
              <label>Historial</label>
              <div className="vp-timeline">
                {timeline.map((t) => (
                  <div key={t.orden} className="vp-timeline-item">
                    <div className="vp-timeline-dot" />
                    <div className="vp-timeline-body">
                      <div className="vp-timeline-comentario">{t.usuario} - {t.comentario}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="crm-modal-buttons">
          {puedeMarcarRealizada && (
            <button type="button" className="btn-primario-solido" onClick={() => onEditarEstatus(visita)}>Marcar como realizada</button>
          )}
          {esRealizada && (
            <button type="button" className="btn-primario-solido" onClick={() => onAgregarComentario(visita)}>Agregar comentario</button>
          )}
          {esRealizada && puedeRevertir && (
            <button type="button" className="btn-primario-solido" onClick={() => onRevertirEstatus(visita)}>Revertir estatus</button>
          )}
          {!esRealizada && (
            <button type="button" className="btn-primario-solido" onClick={() => onEditar(visita)}>Editar visita</button>
          )}
        </div>
      </div>
    </Modal>
  );
};
